import React from "react";
import { Table, Badge, Button } from "react-bootstrap";
import styles from "./UserList.module.css";
import { formatDateTime } from "../../../utils/formatters";
import { API_BASE_URL } from "../../../utils/constants";

const statusVariant = (status) => {
  switch (status) {
    case "creating":
      return "info";
    case "registration":
      return "primary";
    case "blocked":
      return "danger";
    case "deleted":
      return "warning";
    default:
      return "success";
  }
};

const statusTranslate = (status) => {
  switch (status) {
    case "done":
      return "Зарегистрирован";
    case "registration":
      return "Регистрация";
    case "creating":
      return "Создан";
    case "blocked":
      return "Заблокирован";
    case "deleted":
      return "Удален";
    default:
      return status;
  }
};

const UserList = ({ users, onView }) => {
  return (
    <div className={styles.tableWrapper}>
      <Table responsive hover size="sm">
        <thead>
          <tr>
            <th>ID</th>
            <th>Аватар</th>
            <th>Имя / логин</th>
            <th>Email / телефон</th>
            <th>Статус</th>
            <th>Верификация</th>
            <th>Дата регистрации</th>
            <th />
          </tr>
        </thead>
        <tbody>
          {users.map((u) => {
            return(
            <tr key={u._id}>
              <td>{u._id}</td>
              <td>
                {u.profileImage?.[0]?.path ? (
                  <img
                    src={API_BASE_URL + "/" + u.profileImage[0].name}
                    alt=""
                    className={styles.avatar}
                  />
                ) : (
                  <div className={styles.avatarPlaceholder}>—</div>
                )}
              </td>
              <td>
                <div className="fw-semibold">{u.name}</div>
                <div className="text-muted small">{u.login}</div>
              </td>
              <td>
                <div>{u.email || "—"}</div>
                <div className="text-muted small">{u.phone || ""}</div>
              </td>
              <td>
                <Badge bg={statusVariant(u.status)}>
                  {statusTranslate(u.status)}
                </Badge>
              </td>
              <td>{u.isVerify ? "✅" : "❌"}</td>
              <td>{formatDateTime(u.createdAt)}</td>
              <td className="text-end">
                <Button
                  size="sm"
                  variant="outline-primary"
                  onClick={() => onView?.(u)}
                >
                  Просмотр
                </Button>
              </td>
            </tr>
          )})}
          {users.length === 0 && (
            <tr>
              <td colSpan={8} className="text-center text-muted py-3">
                Пользователи не найдены
              </td>
            </tr>
          )}
        </tbody>
      </Table>
    </div>
  );
};

export default UserList;
